/**
 * @file This file contains the DebugManager class, which handles logging
 * and managing the visibility of a debug panel.
 * @module DebugManager
 */

export class DebugManager {
    /**
     * @param {object} domElements - DOM elements required by the DebugManager.
     * @param {HTMLElement} domElements.log - The HTML element where log messages are displayed.
     * @param {HTMLElement} domElements.clearButton - The button to clear the log.
     * @param {HTMLElement} domElements.panelContainer - The container element for the debug panel.
     */
    constructor(domElements) {
        /** @private @type {HTMLElement} */
        this.logElement = domElements.log;
        /** @private @type {HTMLElement} */
        this.clearButton = domElements.clearButton;
        /** @private @type {HTMLElement} */
        this.panelContainer = domElements.panelContainer;
        /** @private @type {boolean} */
        this.isVisible = false;

        this.clearButton.addEventListener('click', () => this.clearLog());
    }

    /**
     * Logs a message to the debug panel.
     * @param {string} message - The message to log.
     */
    log(message) {
        if (this.logElement) {
            this.logElement.innerHTML += `<div>${new Date().toLocaleTimeString()}: ${message}</div>`;
            this.logElement.scrollTop = this.logElement.scrollHeight;
        }
    }

    /**
     * Clears all messages from the debug log.
     */
    clearLog() {
        this.logElement.innerHTML = '';
    }

    /**
     * Toggles the visibility of the debug panel.
     */
    toggleVisibility() {
        this.isVisible = !this.isVisible;
        if (this.isVisible) {
            this.panelContainer.classList.remove('hidden');
        } else {
            this.panelContainer.classList.add('hidden');
        }
    }
}